import { KustomerCoreWindow } from 'core/types';
import { ApiKey } from 'globals/types';

export const getProtocol = () =>
  process.env.NODE_ENV !== 'production' ? 'http' : 'https';
const protocol = getProtocol();

const baseUrlDomain = process.env.API_BASE_URL?.replace(`${protocol}://`, '');

export const parseOrgNameFromApiKey = (apiKey?: ApiKey): string | undefined => {
  try {
    if (!apiKey) throw new Error();

    const parts = apiKey.split('.');

    const tokenPayload = JSON.parse(atob(parts[1]));

    if (!tokenPayload.orgName) {
      throw new Error();
    }
    return tokenPayload.orgName;
  } catch (error) {
    console.error("You've provided an invalid Kustomer api key.");
    return undefined;
  }
};
export const getApiKey = () => {
  const kustomerCoreWindow: KustomerCoreWindow = window.parent;
  return kustomerCoreWindow.KustomerCore?.a;
};

const orgName = parseOrgNameFromApiKey(getApiKey());
export const getEnv = () => ({
  protocol,
  orgName,
  baseUrlDomain,
});
